import { logo1, logo2, logo_new1, logo_new2 } from "../assets";

export const getLogoSrc = (
  language: string,
  isLanguageLoaded: boolean
): string => {
  if (!isLanguageLoaded || language !== "pt") {
    return logo1;
  }
  return logo2;
};

/** For landing page — replaces former logo_new usage */
export const getLogoNewSrc = (
  language: string,
  isLanguageLoaded: boolean
): string => {
  if (!isLanguageLoaded || language !== "pt") {
    return logo_new1;
  }
  return logo_new2;
};
